
import React from "react";
import { useTranslation } from 'react-i18next';
import { TableHeader as UITableHeader, TableRow, TableHead } from "@/components/ui/table";

interface TableHeaderProps {
  isChippingTest: boolean;
  isSpecialPutts: boolean;
  getTableHeadTitle: () => string;
  isWedgingTest?: boolean;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  isChippingTest,
  isSpecialPutts,
  getTableHeadTitle,
  isWedgingTest = false
}) => {
  const { t } = useTranslation('training');
  const title = getTableHeadTitle();
  console.log("TableHeader - title:", title);
  console.log("TableHeader - isChippingTest:", isChippingTest);
  console.log("TableHeader - isWedgingTest:", isWedgingTest);
  
  return (
    <UITableHeader>
      <TableRow>
        <TableHead className="w-[100px]">{t('interface.tableHeaders.point')}</TableHead>
        <TableHead className="w-[100px]">{t('interface.tableHeaders.distance')}</TableHead>
        {Array.from({ length: 10 }, (_, i) => (
          <TableHead key={i} className="text-center">
            {i + 1}
          </TableHead>
        ))}
        <TableHead className="text-center">{t('interface.tableHeaders.total')}</TableHead>
      </TableRow>
    </UITableHeader>
  );
};

export default TableHeader;
